(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'Reminder',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	// form.load = function load()
	// {
	// };

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			Adzuki.StatusMessage(null, 'Your reminder has been set.', 'Saved!');

			$(".reminders-link a").qtip('hide');
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving travel type');
		return false;
	};

}(jQuery, window.Adzuki || {}));